import { Select, Option, Typography } from '@material-tailwind/react';

const MsgInputError = ({ text = '' }) => {
  return (
    <div className="mt-1">
      <Typography
        color="red"
        variant="small"
        className=" ml-1 font-serif dark:font-bold   dark:text-darkErroText"
      >
        {text}
      </Typography>
    </div>
  );
};

export default MsgInputError;
